import * as z from 'zod';
import { PostalCodeSchema } from '../postalCodeSchema';

export const parsePostalCodeList = (value: unknown) => {
    return z.array(PostalCodeSchema).parse(value);
};
